/// <reference path="../Constants.js" />

window.ChartSetupUIObj = function () {
    function getBitFlags(checkboxClass) {
        var val = 0;
        $(checkboxClass + "[type='checkbox']:enabled").each(function () {
            if ($(this).is(":checked"))
                val += parseInt($(this).val() || 0, 10);
        });
        return val;
    }

    return {
        ApplySortValues: function (groupedItems, axis, sortValues) {
            var a = $.grep(groupedItems, function (v, i) {
                return v.position == axis;
            });
            $.each(a, function (i, v) {
                v.sortValue = sortValues[i] || '';
            });
        },
        GetSelectedFilters: function () {
            var filters = [];

			$("#filterBox > div:not('.filterboxTemplate'), #loopIteratorFilters > div").each(function () {
                var filterId = $(this).find("#hidFilterId").val();
                var questionId = $(this).find('#hidQuestionId').val();
                var isConnectedToWeights = $(this).find("#hidIsConnectedToWeights").val();

                var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

                var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
					filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).
					map(function () {
                        return { answerId: $(this).val(), answerText: $(this).text() };
					}).toArray();

                var isCompare = $(this).find("#chkCompare").attr("checked");
                var useDynamicWeighting = isCompare && !!$(this).find("#chkUseDynamicWeighting:checked").length;
                var filterText = $(this).find('h3').text();

                if ($(selectedAnswers).length > 0) {
                    var filter = {
                        filterId: filterId,
                        answers: selectedAnswers,
                        compare: isCompare,
                        questionId: questionId,
                        filterText: filterText,
                        allAnswers: allAnswers,
                        isConnectedToWeights: isConnectedToWeights,
                        useDynamicWeighting: useDynamicWeighting
                    };

                    filters.push(filter);
                }
            });

            return filters;
        },
        GetDatagroupFromGui: function () {
            var datagroup = ChartSetupDataBinding.GetBoundDataGroup() || {};
            datagroup.groupName = $("#txtSeriesName").val() || datagroup.groupName;
	        datagroup.contentType = ChartSetupDataBinding.GetBoundContentType();
	        datagroup.calculationType = $("#ddlCalculationType").val() || Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT;
	        datagroup.numericPercentileValue = $('#numericPercentileValue').val();
            datagroup.questionSelections = ChartSetupUIObj.GetQuestionSelections();
            datagroup.correlationSettings = ChartSetupUIObj.GetCorrelationSettings();
            datagroup.filters = ChartSetupUIObj.GetSelectedFilters();
            datagroup.useWeight = $("#chkUseWeight").attr("checked");
            datagroup.weightVariableId = $("#ddlWeight").val();
            datagroup.timeSelections = ChartSetupUIObj.GetTimeSelections();
            datagroup.groupedItems = ChartSetupUIObj.GetGroupings();
            datagroup.seriesSettings = ChartSetupUIObj.GetGroupingSettings();
            datagroup.textOptions = ChartSetupUIObj.GetTextOptions();
            datagroup.axisOptions = ChartSetupUIObj.GetAxisOptions();
            datagroup.chartOptions = ChartSetupUIObj.GetChartOptions();
            datagroup.detailTables = ChartSetupUIObj.GetDetailTables();
            datagroup.hFilterRules = ChartSetupUIObj.GetHFilterRules();
            datagroup.benchmarkSettings = ChartSetupUIObj.GetBenchmarkSettings();
            datagroup.sortingInfo = ChartSetupUIObj.GetSortingInfo();
            datagroup.useSecondaryAxis = datagroup.axisOptions.useSecondaryAxis;
            datagroup.significanceOptions = ChartSetupUIObj.GetSignificanceOptions();
            datagroup.targetAreas = ChartSetupUIObj.GetTargetAreas();
            datagroup.formattingRulesIds = ChartSetupUIObj.GetFormatRules();
            datagroup.defaultAxisBehavior = ChartSetupUIObj.GetDefaultAxisBehavior();
            datagroup.calculationOptions = ChartSetupUIObj.GetCalculationOptions();
			datagroup.meanSeriesSettings = ChartSetupUIObj.GetMeanSeriesSettings();
			datagroup.aggregatedSeriesSettings = ChartSetupUIObj.GetAggregatedSeriesSettings();
            datagroup.usePercentile = ChartSetupUIObj.GetPercentileEnable();
            datagroup.startPercentile = ChartSetupUIObj.GetStartPercentile();
            if (datagroup.usePercentile)
                datagroup.percentiles = ChartSetupUIObj.GetPercentiles();
            datagroup.useMainOptionalFilterSettings = $("#chbUseMainOptFilterSettings").attr("checked");
            datagroup.optionalFilterSettings = ChartSetupUIObj.GetOptionalFilterSettings();
            datagroup.heatmapSettings = ChartSetupUIObj.GetHeatmapSettings();
            datagroup.gradientStops = ChartSetupUIObj.GetGradientStops();
            datagroup.exportAsScreenshot = $('#chbExportTableAsScreenshot').is(':checked');
			datagroup.nestFilterCompares = $('#chbNestCompareFilters').is(':checked');
            datagroup.useThreshold = $('#chbThreshold').is(':checked');
            if (datagroup.useThreshold) {
                datagroup.thresholdValue = $('#txtThresholdValue').val();
                datagroup.colorAbove = $('#txtColorAbove').DUIColorPicker('get.selectedColor');
                datagroup.colorAbove_colorPlaceholderId = $('#txtColorAbove').DUIColorPicker('get.selectedColorId');
                datagroup.colorBelow = $('#txtColorBelow').DUIColorPicker('get.selectedColor');
                datagroup.colorBelow_colorPlaceholderId = $('#txtColorBelow').DUIColorPicker('get.selectedColorId');
            }
            datagroup.rankSettings = ChartSetupUIObj.GetRankSettings();
            datagroup.customHeaders = ChartSetupUIObj.GetCustomHeaders();
            datagroup.version = $("#dgVersion").val();
            datagroup.overrideMainFormatRules = !datagroup.isMain && !$("#chkUseMainFormattingRules").is(':checked');
            datagroup.allowExcelExport = $("#chbAllowExcelExport").is(":checked");
			datagroup.allowCsvExport = $("#chbAllowCSVExport").is(":checked");
			datagroup.applySmartPositioning = false;
            datagroup.referenceDataSettings = ChartSetupUIObj.GetReferenceDataSettings();
            datagroup.useRespondentsForBaseInLoopedQuestion = $("#chbUseRespondents").is(":enabled:checked");
            datagroup.exportToEditablePptAsImage = $('#chbExportToEditablePPTAsImage').is(':checked');
            
            return datagroup;
        },
        GetCorrelationSettings: function () {
        	return {
        		questionId: $("#correlationQuestionBox").val() || 0,
        		correlationOption: $("#ddlCorrelationOption").val() || 1
        	};
        },
        GetHeatmapSettings: function () {
            return {
                autoRadius: $("#chbAutoRadius").attr("checked"),
                autoGradient: $("#chbAutoGradient").attr("checked"),
                radius: $("#txtCustomRadius").val() || 0,
                opacity: $("#txtOpacity").val() || 100,
                legendItemTypeId: $("#ddlHeatMapLegend").val() || 0,
                legendPosition: $("#ddlHMLegendPosition").val() || "br"
            };
        },
        GetMeanSeriesSettings: function () {
            return {
                enabled: $("#chbEnableMeanValueSeries").attr("checked"),
                orientation: $("#ddlMeanValueOrientation").val() || 1,
                considerBase: $("#chbConsiderBase").attr("checked"),
                hideOriginalSeries: $("#chbHideOriginalSeries").attr("checked"),
                position: $("#ddlMeanSeriesPosition").val() || 1,
                label: $("#txtMeanSeriesLabel").val() || "",
                color: $("#txtMeanSeriesColor").DUIColorPicker('get.selectedColor') || "",
                color_colorPlaceholderId: $("#txtMeanSeriesColor").DUIColorPicker('get.selectedColorId') || "",
                subgroup: $("#ddlMeanSeriesSubgroup").val() || "0",
				runBeforeTopByValue: $("#chbRunAfterMeanAggregate").attr("checked")
            };
		},
		GetAggregatedSeriesSettings: function () {
			return {
				enabled: $("#chbEnableAggregatedSeries").attr("checked"),
				orientation: $("#ddlAggrSeriesOrientation").val() || 1,
				hideOriginalSeries: $("#chbAggrHideOriginalSeries").attr("checked"),
				position: $("#ddlAggregatedSeriesPosition").val() || 1,
				label: $("#txtAggregatedSeriesLabel").val() || "",
				color: $("#txtAggregatedSeriesColor").DUIColorPicker('get.selectedColor') || "",
				color_colorPlaceholderId: $("#txtAggregatedSeriesColor").DUIColorPicker('get.selectedColorId') || "",
				subgroup: $("#ddlAggregatedSeriesSubgroup").val() || "0",
				runBeforeTopByValue: $("#chbRunAfterMeanAggregate").attr("checked"),
				stopOnMissingValue: $('#chbAggrStopOnMissingValue').attr('checked')
			};
		},
        GetTopValuesPerGroupNames: function () {
            var tableId = "tblShowTopValuePerGroupNames", rowTemplateClass = "serieNameTemplate";
            var names = [];
            $("#" + tableId + " > tbody > .serieNameRow:not('." + rowTemplateClass + "')").each(function () {
                names.push($(this).find("#txtTopSerieName").val());
            });

            return names;
        },
        GetGradientStops: function () {
            var tableId = "tblHeatMapGradient", rowTemplateClass = "heatmapGradientTemplate";
            var stops = [];
            $("#" + tableId + " > tbody > .heatmapGradientRow:not('." + rowTemplateClass + "')").each(function () {
                var stopValue = $(this).find("#txtGradientStop").val();
                var color = $(this).find("#clGradientColor").val();
                if (stopValue && color) {
                    var gs = {
                        stopValue: stopValue,
                        color: color
                    };
                    stops.push(gs);
                }
            });

            return stops;
        },
        GetTargetAreas: function () {
            var taTableId = "targetAreasTable", taRowTemplateClass = "targetAreaTemplate";
            var targetAreas = [];
            $("#" + taTableId + " > tbody > .targetAreaRow:not('." + taRowTemplateClass + "')").each(function () {
                var startValue = $(this).find("#txtStartValue").val();
                var stopValue = $(this).find("#txtStopValue").val();
                var color = $(this).find("#txtTargetAreaColor").DUIColorPicker('get.selectedColor');
                var color_colorPlaceholderId = $(this).find("#txtTargetAreaColor").DUIColorPicker('get.selectedColorId');
                if (startValue && stopValue && color) {
                    var ta = {
                        startValue: startValue,
                        stopValue: stopValue,
                        color: color,
                        color_colorPlaceholderId: color_colorPlaceholderId
                    };
                    targetAreas.push(ta);
                }
            });

            return targetAreas;
        },
        GetFormatRules: function () {
            var rulesIds = [];
            if ($("#formatRulesIds").val()) {
                rulesIds = $("#formatRulesIds").val().split(',');
                for (var i = 0; i < rulesIds.length; i++) {
                    rulesIds[i] = parseInt(rulesIds[i], 10);
                }
            }
            return rulesIds;
        },
        GetBenchmarkSettings: function () {
			var benchmarkValue = $('#ddlBenchmarkGrouping').val();
			var matchType = parseInt($('#ddlBenchmarkMatchBy').val() || 1, 10);
			if (matchType === 2)
				matchType = $('#ddlBenchmarkMatchByText').val() || 2;

            return {
                isEnabled: $("#chkEnableBenchmark").attr("checked"),
                value: benchmarkValue,
                typeId: Storyboard.Constants.GroupTypes.getGroupItem(benchmarkValue).groupType,
                axis: $('#ddlBenchmarkAxis').val(),
                calculationType: $('#ddlBenchmarkCalculationType').val(),
                comparisonType: $('#ddlBenchmarkComparisonType > option:selected').val(),
                foldingOption: $('#ddlBenchmarkFoldingOption').val(),
                benchmarkPlacement: $("#ddlBenchmarkPlacementOption").val() || 0,
                showBenchmarkOnly: $('#chbShowOnlyBenchmarks').attr('checked'),
                sortOnBenchmark: $('#chbSortBenchmarks').attr("checked"),
				sortOrder: $('#ddlBenchmarkSorting').val() || 1,
				pointMatchType: matchType
            };
        },
        GetSortingInfo: function () {
            var sortSelections = Storyboard.FilterSort.getSelections();
            return {
                axisSort: sortSelections['axis'].sort || 0,
                legendSort: sortSelections['legend'].sort || 0,
                foreignDataGroupId: sortSelections['axis'].foreignDataGroupId || 0,
                enableColumnSort: $("#chbEnableColumnSort").attr("checked")
            };
        },
        GetDataGroupInfo: function () {
            return {
                dataGroupId: parseInt($("#hidDataGroupId").val() || "0"),
                elementItemId: parseInt($("#hidElementItemId").val() || "0"),
                guid: $("#hidElementGuid").val() || '',
                dgGuid: $("#hidDataGroupGuid").val()
            };
        },
        GetQuestionSelections: function () {
            var questionSelections = {};
            questionSelections.questionBlocks = $('#lbQB').val() || [];
            questionSelections.variableSubsets = $('#lbVS').val() || [];
            questionSelections.gridQuestions = $('#lbGQ').val() || [];
            questionSelections.questions = ChartSetupUIObj.GetSelectedQuestions();
            questionSelections.allAnswersQuestions = $("#answerbox option[value='all']:selected").length > 0 ? questionSelections.questions : [];
            questionSelections.allQuestions = $("#questionBox").val() == "all";
            questionSelections.allAnswers = $("#answerbox option[value='all']:selected").length > 0;

            var isAnswerBased = Storyboard.Constants.CalculationTypes.isAnswerBased($("#ddlCalculationType").val());
            questionSelections.answersExcludedFromPercentage = [];
            if (isAnswerBased)
                $('#answerbox option[excludeFromPercentage="true"]').each(function () { questionSelections.answersExcludedFromPercentage.push($(this).val()); });

            if (isAnswerBased && $("#answerbox option[value='all']:selected").length < 1)
                questionSelections.answers = $('#answerbox').val() || [];
            else {
            	var selectedAnswers = [];
            	$('#answerbox option[value!="all"]').each(function () { selectedAnswers.push($(this).val()); });
            	questionSelections.answers = selectedAnswers;
            }
            return questionSelections;
        },
        GetSelectedQuestions: function () {
        	var selectedQuestions = [];
        	if ($("#questionBox option[value='all']:selected").length > 0) {
        		$('#questionBox option[value!="all"]').each(function () { selectedQuestions.push($(this).val()); });
        	} else
        		selectedQuestions = $("#questionBox").val() || [];

        	return selectedQuestions;
        },
        GetTimeSelections: function () {
            var timeSelections = {};
            timeSelections.timePeriod = $("#ddlTimePeriod").val() || 0;
            timeSelections.timePeriodSpan = $("#ddlTimePeriodSpan").val() || 1;
            timeSelections.timePeriodSpanAmount = $("#txtTimePeriod").val() || 0;
            timeSelections.timeInterval = $("#ddlInterval").val() || 7;
            timeSelections.movingAverage = $("#ddlMovingAverage").val() || 1;
            timeSelections.showMovingAverageSpan = $("#chbShowMovingAverageSpan").is(":checked");
            timeSelections.showPreviousIntervals = $("#chbShowPreviousIntervals").is(":checked");
            timeSelections.startDate = $('#txtStartDate').datepicker('getDate') || new Date(1, 1, 1);
            timeSelections.stopDate = $('#txtStopDate').datepicker('getDate') || new Date(1, 1, 1);
            timeSelections.strStartDate = Helpers.formatDate(timeSelections.startDate);
            timeSelections.strStopDate = Helpers.formatDate(timeSelections.stopDate);
            timeSelections.dateVariableId = $("#ddlDateVar").val();
            timeSelections.includeTheSamePeriodOfPreviousYears = $('#chbIncludeTheSamePeriodOfPreviousYears').is(":checked");
            timeSelections.includePreviousPeriods = $('#chbIncludePreviousPeriods').is(":checked");
            timeSelections.numberOfPreviousYears = $("#txtNumberOfPreviousYears").val() || 1;
            timeSelections.numberOfPreviousPeriods = $("#txtNumberOfPreviousPeriods").val() || 1;

            return timeSelections;
        },
        GetDynamicColorStops: function() {
            var dynColorStops = [];
            $('#dynamicColorsTable').find('tr[id^="dynamicColorStop_"]').each(function () {
                var index = $(this).attr('id').split('_')[1];
                var stopVal = $(this).find('#dynamicColorStopValue_' + index).val();
                var $dynColPreview = $(this).find('#dynamicColorPreview_' + index);

                dynColorStops.push({
                    color: Helpers.convertFromHexToDecimal($dynColPreview.attr('title')),
                    stop: !isNaN(stopVal) ? parseFloat(stopVal) : 0,
                    colorPlaceholderId: $dynColPreview.DUIColorPicker('get.selectedColorId')
                });
            });

            return dynColorStops;
        },
        GetGroupingSettings: function () {
            return {
                seriesType: $("#ddlSeriesType option:selected").val() || 0,
                seriesAttribute: $("#ddlSeriesOptions").val() || "0",
                SeriesLayoutAlgorithm: $("#ddlSeriesLayoutOptions").val() || "0",
                invertChart: $("#chkInvertChart").attr("checked"),
                seriesColorSource: $("#ddlColorLogic").val(),
                seriesGradientType: $('#ddlGradientType').val(),
                seriesColorValueSource: $('#ddlColorValueSource').val(),
                seriesGradientMinValue: $('#txtGradientMinValue').val(),
                seriesGradientMaxValue: $('#txtGradientMaxValue').val(),
                seriesColor: Helpers.convertFromHexToDecimal($('#seriesColorPreview').attr('title')),
                seriesColor_colorPlaceholderId: $('#seriesColorPreview').DUIColorPicker('get.selectedColorId'),
                colorStops: ChartSetupUIObj.GetDynamicColorStops(),
                seriesColorCategoryId: $('#seriesColorCategory').val(),
                seriesStripSettings: ChartSetupUIObj.GetSeriesStripSettings(),
                showDataLabel: $("#cbShowValues").attr("checked"),
                noofDecimals: $("#txtNoofDecimals").val() || 0,
                legendPosition: $("#ddlLegendPosition").val() || 1,
                showTopSeries: $("#txtShowTopSeries").val() || 0,
                showTopSeriesTo: $("#txtShowTopSeriesTo").val() || 0,
                runTopSeriesAfterRankSigTestBm: $("#ddlRunTopSeriesAfterOp").val() == 0 ? false : true,
                showTopSeriesOrientation: $("#ddlShowTopSeriesOrientation").val() || 0,
                showTopSeriesMode: $("#ddlShowTopSeriesMode").val() || 0,
                showTopValuesPerGroup: $("#txtShowTopValuesPerGroup").val() || 0,
                showTopValuesPerGroupOrientation: $("#ddlShowTopValuesPerGroupOrientation").val() || 0,
                showTopValuesPerGroupNames: ChartSetupUIObj.GetTopValuesPerGroupNames(),
                showTopValuesSubgroup: $("#ddlTopValuesSubgroups").val() || "0",
                matchXAxisOnText: $("#chbMatchXAxisOnText").attr("checked"),
                isPosNeg: $("#chkApplyPosNeg").attr("checked"),
                showUnitOnDataLabel: $("#chkShowUnitOnDataLabel").attr("checked"),
                showSeparatorOnDataLabel: $("#chbShowSeparatorOnDataLabel").attr("checked"),
                matchSeriesOnColumnText: $('#chbMatchseries').attr("checked"),
                matchSeriesOnRowText: $('#chbMatchSeriesRows').attr("checked"),
                useTwoLabelColorLogic: $("#chbUseTwoColorLogic").attr("checked"),
				labelColorForLightBg: $("#txtLabelColorForLightBg").attr("title") || "",
				labelColorForLightBg_colorPlaceholderId: $('#txtLabelColorForLightBg').DUIColorPicker('get.selectedColorId'),
				labelColorForDarkBg: $("#txtLabelColorForDarkBg").attr("title") || "",
				labelColorForDarkBg_colorPlaceholderId: $('#txtLabelColorForDarkBg').DUIColorPicker('get.selectedColorId'),
				exportAllSeriesToExcel: $("#chbExcelExportAllSeries").attr("checked"),
                renderValueType: $('#dllGenerateByDecimals').val() || 1,
                valueBasedColoring: ChartSetupUIObj.GetValueBasedColoring(),
                excludeZeroFromTopSeries: $('#chbExcludeZeroFromTopBottom').attr("checked"),
                useTableHeatmapColors: $("#chbUseTableCellGradient").attr("checked")
            };
        },
		GetSeriesStripSettings: function () {
            return {
                seriesStripType: getBitFlags('.seriesTrimming'),
                hideSeriesLimit: $('#txtTrimLowBase').val() || 0,
                hideSeriesType: $('#ddlTrimType').val(),
                hideValueType: $('#ddlTrimLowBase').val() || 0,
                hideSeriesMessage: $('#txtTrimLowBaseMessage').val(),
                warningLimit: $('#txtWarnLowBase').val() || 0,
                baseSizeWarningLimitId: $('#ddlWarnLimits').val() || 0,
                baseSizeHideLimitId: $('#ddlHideLimits').val() || 0,
                warningValueType: $('#ddlWarnLowBase').val() || 0,
                warningMessage: $('#txtWarnLowBaseMessage').val(),
                hideLowResultObject: $("#ddlTrimLowResultObject").val() || 1,
                hideLowResultLimit: $("#txtTrimLowResultValue").val() || 0,
                hideLowResultType: $("#ddlTrimLowResultType").val() || 0,
                hideLowResultMessage: $("#txtTrimLowResultMessage").val(),
				hideLowResultBaseType: $("#ddlTrimLowResultUseWeight").val() || 1,
				applyMainHideLowBaseSettings: $('#chbTrimLowBaseByMain').attr("checked"),
				applyMainHideLowResultSettings: $('#chbTrimLowResultByMain').attr("checked"),
				applyMainWarnLowBaseSettings: $('#chbWarnLowBaseByMain').attr("checked")
            };
        },
        GetTextOptions: function () {
            return {
                showQuestionTexts: $("#cbShowQuestionTexts").attr("checked"),
                showAnswerTexts: $("#cbShowAnswerTexts").attr("checked"),
                showFilterTexts: $("#cbShowFilterTexts").attr("checked"),
                showTimeIntervalTexts: $("#cbShowTimeIntervalTexts").attr("checked"),
                showThousandSeparator: $("#cbShowThousandSeparator").attr("checked"),
                showPositivePrefix: $("#chbShowPositivePrefix").attr("checked"),
                useCustomColumnHeaders: $("#chkEnableCustomColumnHeaders").attr("checked"),
                useCustomRowHeaders: $("#chkEnableCustomRowHeaders").attr("checked")
            };
        },
        GetValueBasedColoring: function () {
            var valueBasedColoring = [];
            $('#tblValueBasedColors').find('tr[id^="valueBasedColor_"]').each(function () {
                var index = $(this).attr('id').split('_')[1];
                var startVal = $(this).find('#valueBasedStartValue_' + index).val();
                var endVal = $(this).find('#valueBasedStopValue_' + index).val();
                var startConditionValue = $(this).find('#valueBasedStartCondition_' + index).val();
                var endConditionValue = $(this).find('#valueBasedStopCondition_' + index).val();
                var $valBsdColPreview = $(this).find('#ValueBasedColorsPreview_' + index);
                startVal = startVal == "" ? 0 : parseFloat(startVal);
                endVal = endVal == "" ? 0 : parseFloat(endVal);
                if (isNaN(startVal))
                    startVal = 0;
                if (isNaN(endVal))
                    endVal = 0;
              
                    valueBasedColoring.push({
                        ColorHex: $valBsdColPreview.attr('title'),
                        Color: Helpers.convertFromHexToDecimal($valBsdColPreview.attr('title')),
                        StartValue: startVal,
                        EndValue: endVal,
                        StartConditionValue: startConditionValue,
                        EndConditionValue: endConditionValue,
                        colorPlaceholderId: $valBsdColPreview.DUIColorPicker('get.selectedColorId')
                    });
                
               
            });

            return valueBasedColoring;
        },
        btnExportInfo: function () {
            var html =
                "<div>" +
                '<p>Note, when the chart is exported to PowerPoint as editable objects the chart legend may not match the online appearance due to limitations in PowerPoint\'s chart functionality. If charts are exported to PowerPoint as images the legend will match the online appearance.</p>' +
                "</div>";

            new DUIwindow2({
                title: "",
                width: 510,
                padding: 45,
                buttonsHeight: 50,
                buttons: [],
                html: html,
                modal: true,
                preWrapSpace: false
            });
        },
        GetGroupings: function () {
            if (ChartSetupDataBinding.GetBoundDataGroup()) {
                var groupedItems = ChartSetupDataBinding.GetBoundDataGroup().groupedItems;
                var consts = Storyboard.Constants;
                var sortInfo = Storyboard.FilterSort.getSelections();

                /* yes, grouped items on legend should be mapped to sortinfo on axis. no typo */
                this.ApplySortValues(groupedItems, consts.Axis.axis, sortInfo['legend'].sortValues);
                this.ApplySortValues(groupedItems, consts.Axis.legend, sortInfo['axis'].sortValues);

                return groupedItems;
            }
            else
                return [];
        },
        GetAxisOptions: function () {
            return {
                xAxisText: $("#txtXAxis").val() || "",
                yAxisText: $("#txtYAxis").val() || "",
                minScale: $("#txtMinScale").val().replace(',', '.'),
                maxScale: $("#txtMaxScale").val().replace(',', '.'),
                axisUnitName: $('#txtAxisUnitName').val() || "",
                axisUnitPlacement: $('#ddlAxisUnitPlacement').val(),
                showUnitOnYAxis: $('#chbShowUnitOnYAxis').is(':checked'),
                showSeparatorOnYAxis: $('#chbShowSeparatorOnYAxis').is(':checked'),
                useSecondaryAxis: $("#chbUseSecondaryAxis").is(':checked'),
                isSecondary: $("#chbUseSecondaryAxis").is(':checked'),
                autoGrid: $("#chkAutoGrid").is(':checked'),
                gridInterval: $("#txtGridInterval").val().replace(',', '.') || "0"
            };
        },
        GetDefaultAxisBehavior: function () {
            return {
                intervalPosition: $("#selectDefaultPlacementInterval option:selected").val(),
                filtersPosition: $("#selectDefaultPlacementFilters option:selected").val()
            };
        },
        GetCalculationOptions: function () {
            return {
                GroupDataBy: $("#ddlGroupDataBy option:selected").val(),
                BaseVariable: $("#ddlBaseVariable option:selected").val(),
                RebasePercentageShare: $("#rbTotalBase").is(':enabled:checked') || $('#rbFromOtherQuestion').is(':enabled:checked'),
                RebasePercentageShareUsingTotalBase: $("#rbTotalBase").is(':enabled:checked'),
                RebasePercentageShareQuestionID: $('#rbFromOtherQuestion').is(':enabled:checked') ? $('#ddlRebaseVariable option:selected').val() : 0
            };
        },
        GetChartOptions: function () {
        	var contentType = ChartSetupDataBinding.GetBoundContentType();
        	var baseSizePosition = parseInt($("#ddlBasePosition").val() || 1, 10);
        	var seriesType = $("#ddlSeriesType option:selected").val() || 0;
        	// different dropdown is used in simple table
        	if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE)
        		baseSizePosition = parseInt($("#ddlTableBasePosition").val() || 3, 10);
        	return {
                showFilterInTitle: $("#chbShowFilterInTitle").attr("checked"),
                tooltipItems: getBitFlags(".tooltipItems"),
                baseSizeOption: $("#ddlShowBase").closest(".additionalChart").css("display") === "none" ? 0 : parseInt($("#ddlShowBase").val() || 0, 10),
                baseSizeLabel: $("#txtBaseSizeLabel").val() || "",
                baseSizePosition: baseSizePosition,
                baseSizeOrientation: parseInt($("#ddlTableBaseOrientation").val() || 1, 10),
                transformIntoPolar: Storyboard.Constants.SeriesTypes.canBePolar(seriesType) ? $('#chbTransformIntoPolar').attr("checked") : false,
                allowChartZoom: $('#chartZooming').attr("checked"),
                enableTooltip: $("#chbEnableTooltip").attr("checked"),
                showMagnifyingGlass: $("#chbShowMagnifyingGlass").attr("checked"),
                innerRadius: parseInt($("#ddlGaugeDonutInnerRadius").val() || 50, 10),
                autoColumnBarWidth: $("#chkAutoSeriesPointWidth").attr("checked"),
                repeatedTextInLegendHeader: false
            };
        },
        GetChartStyles: function (setupContainer, idPrefix) {
            setupContainer = setupContainer || $("#setupChart #layout");
            idPrefix = idPrefix || 'chartstyle_';

			var settings = [];
			var hideXAxisTicks, hideYAxisTicks;
            var setting;
            var name;
            var axis, settingKeys;
            var value;
            $('.ChartStyleSettingControl', setupContainer).each(function (index) {
                name = $(this).attr('id').replace(idPrefix, '');
                if ($(this).is('input:text')) {
                    value = '';
                    if ($(this).hasClass('numInput'))
                        value = $(this).val();
                    else {
                        value = (
							typeof this.style.backgroundColor == 'undefined' ||
							this.style.backgroundColor.replace(/ /g, '').indexOf('(255,255,255,0') > -1 ||
							this.style.backgroundColor.toLowerCase() == 'transparent' ||
							this.style.backgroundColor.toLowerCase() == 'initial'
						)
						? 'rgba(255, 255, 255, 0.001)'
						: this.style.backgroundColor;
                    }
                    setting = {
                        settingKey: name,
                        settingValue: value
                    };
                    settings.push(setting);

                    // Give same color to axes tickMarks
                    if (name.indexOf('Axis') > -1 && name.indexOf('lineColor') > -1) {
                        axis = name.indexOf('yAxis') > -1 ? "y" : "x";
                        settingKeys = [axis + 'Axis_tickColor', axis + 'Axis_minorTickColor'];
                        $(settingKeys).each(function (index) {
                            setting = {
                                settingKey: $(settingKeys)[index],
                                settingValue: value
                            }
                            settings.push(setting);
                        });
                    }

                    // Give same textcolor on hover as non-hover
                    if (name.indexOf('legend') > -1 && name.indexOf('itemStyle_color') > -1) {
                        setting = {
                            settingKey: 'legend_itemHoverStyle_color',
                            settingValue: value
                        }
                        settings.push(setting);
                    }

                    // Create template color setting
                    if ($(this).hasClass('colorpicker-target') && $(this).DUIColorPicker('get.selectedColorId')) {
                        var templateName = name + '_colorPlaceholderId';
                        var templateValue = $(this).DUIColorPicker('get.selectedColorId');
                        setting = {
                            settingKey: templateName,
                            settingValue: templateValue
                        }
                        settings.push(setting);

                        // Give same color to axes tickMarks
                        if (name.indexOf('Axis') > -1 && name.indexOf('lineColor') > -1) {
                            axis = name.indexOf('yAxis') > -1 ? "y" : "x";
                            settingKeys = [axis + 'Axis_tickColor', axis + 'Axis_minorTickColor'];
                            $(settingKeys).each(function (index) {
                                setting = {
                                    settingKey: $(settingKeys)[index] + '_colorPlaceholderId',
                                    settingValue: templateValue
                                }
                                settings.push(setting);
                            });
                        }

                        // Give same textcolor on hover as non-hover
                        if (name.indexOf('legend') > -1 && name.indexOf('itemStyle_color') > -1) {
                            setting = {
                                settingKey: 'legend_itemHoverStyle_color_colorPlaceholderId',
                                settingValue: templateValue
                            }
                            settings.push(setting);
                        }
                    }

                }
                else if (this.nodeName.toLowerCase() == 'select' || $(this).is('input:hidden')) {
                    setting = {
                        settingKey: name,
                        settingValue: $(this).val()
                    };

                    if (setting.settingKey == 'chart_style_fontFamily') {
                        setting.settingValue = Storyboard.LayoutDesigner.UserEvents.getFontStackByFontFamily(setting.settingValue);
                    }

                    var seriesType = $("#ddlSeriesType").val();
                    if (name == 'series_dataLabels_verticalAlign' && seriesType != Storyboard.Constants.SeriesTypes.SCATTER && seriesType != Storyboard.Constants.SeriesTypes.BUBBLE)
                        return;

                    settings.push(setting);

                    // hide axes tickMarks if width of axis line is zero
					if (name.indexOf('Axis') > -1 && name.indexOf('lineWidth') > -1 && parseInt($(this).val()) == 0) {
						if (name.indexOf('yAxis') > -1)
							hideYAxisTicks = true;
						else
							hideXAxisTicks = true;
                    }
                }
                else if (this.nodeName.toLowerCase() == 'span' && $(this).children('input:checkbox').length > 0) {
                    name = $(this).children('input:checkbox').attr('id').replace(idPrefix, '');
                    value = $(this).children('input:checkbox').is(':checked');
                    setting = {
                        settingKey: name,
                        settingValue: value ? "True" : "False"
                    };
                    settings.push(setting);
                } else if ($(this).is('div.DUIButtonsGroupVertical')) {
                    name = $(this).attr('id').replace(idPrefix, '');
                    value = $(this).find('button.active').val();
                    settings.push({
                        settingKey: name,
                        settingValue: value
                    });
                } else if (this.nodeName.toLowerCase() == 'div') {
                    name = $(this).attr('id').replace(idPrefix, '');
                    value = $(this).children('.ChartStyleDashStyleValue').attr('data-value');
                    setting = {
                        settingKey: name,
                        settingValue: value
                    };
                    settings.push(setting);
                }
			});

			// hide axes tickMarks if width of axis line is zero
            var toSetTransparent = [];
			if (hideXAxisTicks) {
                toSetTransparent.push('xAxis_tickColor');
                toSetTransparent.push('xAxis_minorTickColor');
			}
			if (hideYAxisTicks) {
                toSetTransparent.push('yAxis_tickColor');
                toSetTransparent.push('yAxis_minorTickColor');
            }

            var seriesType = parseInt($('#ddlSeriesType').val(), 10);
            if (seriesType == Storyboard.Constants.SeriesTypes.FUNNEL) {
                toSetTransparent.push('yAxis_lineColor');
                toSetTransparent.push('yAxis_labels_style_color');
                toSetTransparent.push('yAxis_gridLineColor');
            }

            for (var key in toSetTransparent)
                if (toSetTransparent.hasOwnProperty(key)) {

                    var settingIndex = settings.map(function (s) { return s.settingKey; }).indexOf(toSetTransparent[key]);
					if (settingIndex > -1)
						settings.splice(settingIndex, 1);

					setting = {
                        settingKey: toSetTransparent[key],
						settingValue: 'rgba(255, 255, 255, 0.001)'
					}
					settings.push(setting);
                }

            return settings;
        },
        GetDetailTables: function () {
            var tables = $.grep($("#lbDetailTables").val(), function (e) { return parseInt(e, 10) !== 0; });
            return $.map(tables, function (dt) { return { tableId: dt }; });
        },
        GetHFilterRules: function () {
            var hFilterRules = [];
            $("#hFilterSelectedComparisonGroups tr").each(function () {
                if (!$(this).hasClass("prototype_hidden") && $(this).find("td").hasClass("selection")) {
                    var hFilterRule = {};
                    hFilterRule.ruleId = $(this).find(".selection input[type='hidden']").val();
					hFilterRule.noOfLevels = $(this).find(".levels").text();
					hFilterRule.applyAccessRights = $(this).find('.chbApplyHFAccessRights').attr('checked');
					hFilterRule.color = Helpers.convertFromHexToDecimal($(this).find('.txtHFRuleColorPreview').attr('title'));
					//hFilterRule.color = $(this).find('.txtHFRuleColorPreview').DUIColorPicker('get.selectedColor') || '',
					hFilterRule.color_colorPlaceholderId = $(this).find('.txtHFRuleColorPreview').DUIColorPicker('get.selectedColorId');
                    hFilterRules.push(hFilterRule);
                }
            });
            return hFilterRules;
        },
		GetSignificanceOptions: function () {

			var matchType = parseInt($('#ddlSigTextMatchBy').val() || 1, 10);
			if (matchType === 2)
				matchType = $('#ddlSigTestMatchByText').val() || 2;

            return {
                isEnabled: $("#chkSignificance").attr("checked") && $('.hdStatistics').css('display') != 'none',
                baseLimit: $("#txtBaseLimit").val() || 0,
                respondentLimit: $("#txtRespondentLimit").val() || 0,
                dataTestType: $("#ddlDataTestType").val() || 0,
				dataCompareType: $("#ddlDataCompareType").val() || 0,
                seriesMatchType: matchType,
                textMatchType: $('#ddlTextMatchType').val() || 1,
                dataCompareItem: $("#ddlDataCompareItem").val() || "0",
                sigLevel: $("#ddlSigLevel").val() || 0,
                significancePlacement: $("#ddlSigPlacementOption").val() || 0,
                baseSizeType: $("#ddlBaseSizeType").val() || 1,
                resultsToShow: $("#ddlSigResultToShow").val() || 1,
                resultVisualization: $("#ddlSigVisualizationType").val() || 1,
                iconWidth: $("#txtSigTestIconWidth").val() || 30,
                iconHeight: $("#txtSigTestIconHeight").val() || 30,
                positiveIconId: $("#hidPositiveIconId").val() || 0,
                negativeIconId: $("#hidNegativeIconId").val() || 0,
                positiveIconContent: $("#positiveIconContent").html() || IconShapeUI.defaultPositiveIcon.content,
                negativeIconContent: $("#negativeIconContent").html() || IconShapeUI.defaultNegativeIcon.content,
            	// if All vs All is used, points should not be hidden
                hideComparisonPoints: $("#ddlDataTestType").val() != 1 && $("#ddlSigTestHidePoints").val() == 1,
                iconPosition: $("#ddlSigIconPosition").val() || "center",
                startingLetter: $("#ddlSigStartingLetter").val() || "a",
                symbolsSet: $("#ddlSigSymbolsSet").val() || 1,
                analysisType: $("#ddlAnalysisType").val() || 0,
                normDataGroupID: isNaN($("#ddlNormSeries").val()) ? 0 : $("#ddlNormSeries").val(),
                normDataGroupGuid: $("#ddlNormSeries").val(),
                baseLimitType: $("#ddlSigTestLimitBase").val() || $("#ddlSigTestLimitBase option:not([disabled])").val(),
                showSigTestValuesInTooltip: $('#chkShowSigValuesInTooltip').attr('checked'),
                useColoredSymbols: $('#chbUseSigSymbolColors').attr('checked')
            };
        },
        GetPercentileEnable: function () {
            return $('#chkPercentile').attr('checked');
        },
        GetStartPercentile: function () {
            return $('#startPercentile').val();
        },
        GetPercentiles: function () {
            var values = [];
            $('.percentileRow').each(function () {
            	var row = new Object();
            	row.PercentileID = parseInt($(this).find('.percentileId').val()) || 0;
                row.Value = $(this).find('.percentilePercentile').val();
                row.Label = $(this).find('.labelPercentile').val();
                row.Colour = $(this).find('.colourPercentile').DUIColorPicker('get.selectedColor');
                row.Colour_colorPlaceholderId = $(this).find('.colourPercentile').DUIColorPicker('get.selectedColorId');
                row.DataGroupID = parseInt($("#hidDataGroupId").val() || "0");

                values.push(row);
            });
            return values;
        },
        GetOptionalFilterSettings: function () {
            var optFilterSettings = [];
            var rowVS = new Object();
            rowVS.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
            rowVS.optionalSettingType = 1;
            rowVS.isApply = $("#chkOptVariableSubset").is(':checked');
            optFilterSettings.push(rowVS);

            var rowHFilter = new Object();
            rowHFilter.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
            rowHFilter.optionalSettingType = 2;
            rowHFilter.isApply = $("#chkOptHFilter").is(':checked');
            optFilterSettings.push(rowHFilter);

            $("#optionalFilterBox div").each(function () {
                var rowFilter = new Object();
                rowFilter.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
                rowFilter.filterId = parseInt($(this).find("#hidOptFilterId").val() || "0");
                rowFilter.questionId = parseInt($(this).find("#hidOptQuestionId").val() || "0");
                rowFilter.optionalSettingType = 3;
                rowFilter.isApply = $(this).find(".chkOptFilter").is(':checked');
                if (rowFilter.filterId > 0)
                    optFilterSettings.push(rowFilter);
            });

            var rowTimePeriod = new Object();
            rowTimePeriod.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
            rowTimePeriod.optionalSettingType = 4;
            rowTimePeriod.isApply = $("#chkOptTimePeriod").is(':checked');
            rowTimePeriod.isApplyDateVariable = $("#chkOptDateVariable").is(':checked');
            optFilterSettings.push(rowTimePeriod);

            var rowInterval = new Object();
            rowInterval.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
            rowInterval.optionalSettingType = 5;
            rowInterval.isApply = $("#chkOptInterval").is(':checked');
            optFilterSettings.push(rowInterval);

            var rowMAvg = new Object();
            rowMAvg.dataGroupId = parseInt($("#hidDataGroupId").val() || "0");
            rowMAvg.optionalSettingType = 6;
            rowMAvg.isApply = $("#chkOptMovingAverage").is(':checked');
            optFilterSettings.push(rowMAvg);
            return optFilterSettings;
        },
        GetRankSettings: function () {
            var rankObject = $("#ddlRankObject").val() || "";
            return {
                isEnabled: $("#chkEnableRanking").attr("checked"),
                showRankOnly: $("#chkShowOnlyRanking").attr("checked"),
                axis: $("#ddlRankingAxis").val() || 1,
                rankObject: rankObject,
                onOptionalFilter: $("#chkRankOnOptionalFilter").attr("checked"),
                optionalFilterItem: $("#ddlRankOptionalFilter").val() || "",
                placement: $("#ddlRankPosition").val() || 1,
				typeId: Storyboard.Constants.GroupTypes.getGroupItem(rankObject).groupType,
				showRankTotalSuffix: $('#chkShowRankTotalSuffix').attr("checked"),
				rankTotalSuffix: $('#txtRankTotalSuffix').val(),
				direction: $('#ddlRankingDirection').val() || 1
            };
        },
        GetCustomHeaders: function () {
            var headers = [];
            var rowQuery =
                "#tblCustomColumnHeaders > tbody > .customHeaderRow:not('.customHeaderTemplate'), " +
                "#tblCustomRowHeaders > tbody > .customHeaderRow:not('.customHeaderTemplate')";
                        
            $(rowQuery).each(function () {
                headers.push({
                    headerId: $(this).find("#hidCustomHeaderId").val() || 0,
                    type: $(this).find("#ddlHeaderType").val() || 2,
                    text: $(this).find("#txtHeaderText").val() || "",
                    axis: $(this).closest("table").attr("id") == "tblCustomColumnHeaders" ? 2 : 1,
                    sortOrder: $(this).find("#ddlHeaderSortOrder").val() || 1,
                    nestingLevel: $(this).find("#ddlNestingLevel").val() || 1
                });
            });

            return headers;
		},
		GetReferenceDataSettings: function () {
			return {
				isEnabled: $('#chbEnableReferenceData').attr('checked'),
				resultType: $('input.refDataResult:checked').val() || 0,
				percentile: $('#txtRefDataPercentile').val() || null,
                placement: $('#ddlRefDataPlacement').val() || 1,
                sortOnRefData: $('#chbSortOnRefData').attr('checked'),
                sortOrder: $('#ddlRefDataSorting').val() || 1,
                sortAxis: $('#ddlRefDataSortAxis').val() || 2
			};
		},
		GetScatterMeanOptions: function () {
            return {
                considerBase: $('#chbScatterMeanConsiderBase').attr('checked'),
                showMeanLines: $('#chbScatterMeanLines').attr('checked'),
                meanLineColor: $('#txtScatterMeanLineColor').DUIColorPicker('get.selectedColor') || '',
				meanLineColor_colorPlaceholderId: $('#txtScatterMeanLineColor').DUIColorPicker('get.selectedColorId') || '',
				meanLineWidth: $('#ddlScatterMeanLineWidth').val(),
                meanLineStyle: $('#divScatterMeanLineStyle').children('.ChartStyleDashStyleValue').attr('data-value'),
                showMeanQuadrants: $('#chbScatterMeanQuadrants').attr('checked'),
                topLeftQuadrantColor: $('#txtScatterMeanTopLeftColor').DUIColorPicker('get.selectedColor') || '',
                topLeftQuadrantColor_colorPlaceholderId: $('#txtScatterMeanTopLeftColor').DUIColorPicker('get.selectedColorId') || '',
                topRightQuadrantColor: $('#txtScatterMeanTopRightColor').DUIColorPicker('get.selectedColor') || '',
                topRightQuadrantColor_colorPlaceholderId: $('#txtScatterMeanTopRightColor').DUIColorPicker('get.selectedColorId') || '',
                bottomLeftQuadrantColor: $('#txtScatterMeanBottomLeftColor').DUIColorPicker('get.selectedColor') || '',
                bottomLeftQuadrantColor_colorPlaceholderId: $('#txtScatterMeanBottomLeftColor').DUIColorPicker('get.selectedColorId') || '',
                bottomRightQuadrantColor: $('#txtScatterMeanBottomRightColor').DUIColorPicker('get.selectedColor') || '',
                bottomRightQuadrantColor_colorPlaceholderId: $('#txtScatterMeanBottomRightColor').DUIColorPicker('get.selectedColorId') || '',
                topLeftPointColor: $('#txtScatterPointTopLeftColor').DUIColorPicker('get.selectedColor') || '',
                topLeftPointColor_colorPlaceholderId: $('#txtScatterPointTopLeftColor').DUIColorPicker('get.selectedColorId') || '',
                topRightPointColor: $('#txtScatterPointTopRightColor').DUIColorPicker('get.selectedColor') || '',
                topRightPointColor_colorPlaceholderId: $('#txtScatterPointTopRightColor').DUIColorPicker('get.selectedColorId') || '',
                bottomLeftPointColor: $('#txtScatterPointBottomLeftColor').DUIColorPicker('get.selectedColor') || '',
                bottomLeftPointColor_colorPlaceholderId: $('#txtScatterPointBottomLeftColor').DUIColorPicker('get.selectedColorId') || '',
                bottomRightPointColor: $('#txtScatterPointBottomRightColor').DUIColorPicker('get.selectedColor') || '',
                bottomRightPointColor_colorPlaceholderId: $('#txtScatterPointBottomRightColor').DUIColorPicker('get.selectedColorId') || ''
			};
		}
    };
}();
